import { useEffect, useState } from 'react';

/**
 * active 가 delay 이상 유지된 뒤에야 true 가 된다.
 * 100ms 만에 끝나는 요청에 스피너를 띄웠다 지우면 화면이 깜빡인 것처럼 보이기 때문에,
 * 실제로 기다림이 체감되는 요청에만 로딩 UI 를 노출한다.
 *
 * 스피너(`Loading`)와 화면 전환 베일(`RouteLoadingVeil`)이 같은 판정을 공유한다.
 */
export const useDelayedFlag = (active: boolean, delay: number) => {
  const [ready, setReady] = useState(active && delay <= 0);
  const [prevActive, setPrevActive] = useState(active);

  // active 가 바뀐 순간을 렌더 중에 반영해 다음 대기를 처음부터 다시 센다
  if (active !== prevActive) {
    setPrevActive(active);
    setReady(active && delay <= 0);
  }

  useEffect(() => {
    if (!active || delay <= 0) return;

    const timer = window.setTimeout(() => setReady(true), delay);
    return () => window.clearTimeout(timer);
  }, [active, delay]);

  return ready;
};
